<router-outlet />
<ngx-sonner-toaster />

@if (_loaderService.getLoading()()) {
    <app-loader [textInfo]="_loaderService.getTextInfo()"></app-loader>
}

@if (!isMobile() && !_router.url.includes('whatsapp') && _router.url !== '/' && _router.url !== '/app/basic') {
    <app-desktop-message></app-desktop-message>
}


@if (_helpService.getStateButtonHelp()() && _router.url !== '/') {
    <app-button-help></app-button-help>
}